import api from "@/api/axios";
import { StoreInfo } from "@/types";

// ============================================
// Types
// ============================================

export interface LoginPayload {
  storeId: string;
  password: string;
}

/** Login response - CHỈ CÓ storeInfo, KHÔNG có token (token nằm trong HttpOnly cookie) */
export interface LoginResponse {
  storeInfo: StoreInfo;
}

export interface GetStoreRawResponse {
  id: string;
  name: string;
  description: string;
  location: string;
  price_range_min: number;
  price_range_max: number;
  open_time: string;
  close_time: string;
  preparation_time: number;
  booking_url: string | null;
  logo_image_url: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  isStoreSession: boolean;
  type: string;
}

export interface GetStoreResponse {
  id: string;
  name: string;
  description: string;
  location: string;
  priceRangeMin: number;
  priceRangeMax: number;
  openTime: string;
  closeTime: string;
  preparationTime: number;
  bookingUrl: string | null;
  logoImageUrl: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  isStoreSession: boolean;
  type: string;
}

// ============================================
// Auth Service
// ============================================

export const authStoreService = {
  /**
   * Login store. Server sẽ set HttpOnly cookies tự động qua Set-Cookie header.
   * Response chỉ chứa storeInfo.
   */
  login: async (payload: LoginPayload): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>(
      "/auth/store/login",
      payload,
    );
    return response.data;
  },

  /**
   * Get current store info. Trình duyệt tự gửi accessToken cookie.
   */
  getMe: async (): Promise<GetStoreResponse> => {
    const response = await api.get<GetStoreRawResponse>("/auth/store/me");
    const data = response.data;
    return {
      id: data.id,
      name: data.name,
      description: data.description,
      location: data.location,
      priceRangeMin: data.price_range_min,
      priceRangeMax: data.price_range_max,
      openTime: data.open_time,
      closeTime: data.close_time,
      preparationTime: data.preparation_time,
      bookingUrl: data.booking_url,
      logoImageUrl: data.logo_image_url,
      isActive: data.is_active,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
      deletedAt: data.deleted_at,
      isStoreSession: data.isStoreSession,
      type: data.type,
    };
  },

  /**
   * Logout. Server sẽ xóa HttpOnly cookies (Max-Age=0).
   */
  logout: async () => {
    await api.post("/auth/store/logout");
  },
};
